module.exports = "<header>\n  <div class=\"spacer\"></div>\n  <button class=\"toggle left\" [ngClass]=\"{'active': isActive('create')}\" [routerLink]=\"['create']\">Add New Actions</button>\n  <button class=\"toggle right\" [ngClass]=\"{'active': isActive('edit')}\" [routerLink]=\"['edit']\">View/Edit</button>\n  <div class=\"spacer\"><a class=\"blue\" [routerLink]=\"['../intro']\">Learn More</a></div>\n</header>\n<main>\n  <router-outlet></router-outlet>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/start/start.component.html
// module id = 1614
// module chunks = 2